import { render, staticRenderFns } from "./VectorMapCard.vue?vue&type=template&id=2ec8c120"
import script from "./VectorMapCard.vue?vue&type=script&lang=js"
export * from "./VectorMapCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports